import { render, staticRenderFns } from "./invoice-record-payment.vue?vue&type=template&id=11378a45"
import script from "./invoice-record-payment.vue?vue&type=script&lang=js"
export * from "./invoice-record-payment.vue?vue&type=script&lang=js"
import style0 from "./invoice-record-payment.vue?vue&type=style&index=0&id=11378a45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports